import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import availabilityShape from '@bibliocommons/bc-prop-types';
import { selectStackMapTransactions } from 'app/selectors/StackMapSelector';
import AvailabilityDetailActions from 'app/actions/AvailabilityDetailActions';
import StackMapActions from 'app/actions/StackMapActions';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

import AvailabilityDetailOverlay from './AvailabilityDetailOverlay';

function mapStateToProps(state) {
  const availabilityDetail = state.get('availabilityDetail');
  const library = selectCurrentLibrary(state);
  const checkILSErrorClassification = availabilityDetail.get('errorClassification');

  return {
    items: availabilityDetail.get('items'),
    subscriptions: availabilityDetail.get('subscriptions'),
    marcHoldings: availabilityDetail.get('marcHoldings'),
    isFetching: availabilityDetail.get('isFetching'),
    stackMapSettings: library.get('stackMap'),
    open: availabilityDetail.get('open'),
    bib: state.getIn(['entities', 'bibs', availabilityDetail.get('metadataId')], Immutable.Map()),
    stackMapOpen: selectStackMapTransactions(state).get('open'),
    showDueDateInCirc: library.get('showDueDateInCirc'),
    showCollectionInCirc: library.get('showCollectionInCirc'),
    isILSDown: checkILSErrorClassification && checkILSErrorClassification.length > 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
    ...bindActionCreators(StackMapActions, dispatch)
  };
}

class AvailabilityDetailOverlayContainer extends React.Component {
  render() {
    const { subscriptions, marcHoldings, items, bib, availabilityDetailActions, isILSDown } = this.props;
    return (
      <AvailabilityDetailOverlay
        bib={bib}
        availabilityDetail={{ subscriptions, marcHoldings, items }}
        open={this.props.open}
        disableClose={this.props.disableClose}
        handleClose={availabilityDetailActions.closeAvailability}
        isFetching={this.props.isFetching}
        stackMapOpen={this.props.stackMapOpen}
        openStackMap={this.props.openStackMap}
        stackMap={this.props.stackMapSettings}
        showDueDateInCirc={this.props.showDueDateInCirc}
        showCollectionInCirc={this.props.showCollectionInCirc}
        isILSDown={isILSDown}
      />
    );
  }
}

AvailabilityDetailOverlayContainer.propTypes = {
  bib: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func.isRequired),
  subscriptions: ImmutablePropTypes.list,
  items: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      label: PropTypes.string,
      items: ImmutablePropTypes.listOf(
        ImmutablePropTypes.contains({
          availability: availabilityShape,
          branch: ImmutablePropTypes.contains({
            code: PropTypes.string,
            name: PropTypes.string
          }),
          branchName: PropTypes.string,
          callNumber: PropTypes.string,
          collection: PropTypes.string,
          copy: PropTypes.string,
          dueDate: PropTypes.string,
          groupName: PropTypes.string,
          local: PropTypes.bool,
          preferred: PropTypes.bool,
          volume: PropTypes.string
        })
      )
    })
  ),
  stackMapOpen: PropTypes.bool,
  stackMapSettings: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool,
    branches: ImmutablePropTypes.listOf(PropTypes.string),
    domain: PropTypes.string
  }),
  marcHoldings: ImmutablePropTypes.list,
  isFetching: PropTypes.bool,
  openStackMap: PropTypes.func,
  disableClose: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  showDueDateInCirc: PropTypes.bool,
  showCollectionInCirc: PropTypes.bool,
  isILSDown: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailOverlayContainer);
